export default __webpack_public_path__ + "static/media/1952.9382ac8f.png";